import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { TransformationSection } from './components/TransformationSection';
import { RealResultsSection } from './components/RealResultsSection';
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const IncludesSection = lazy(() => import('./components/IncludesSection').then(m => ({
  default: m.IncludesSection
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const UrgencyOfferSection = lazy(() => import('./components/UrgencyOfferSection').then(m => ({
  default: m.UrgencyOfferSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = 'ukxbt6i9cor3c23xr4j0lek38bvd3m';
    document.head.appendChild(meta);
    const preconnects = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://cdn.magicpatterns.com'];
    const links: HTMLLinkElement[] = [];
    preconnects.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
      links.push(link);
    });
    return () => {
      document.head.removeChild(meta);
      links.forEach(link => document.head.removeChild(link));
    };
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0" data-mp="85ukfuxai55e">
      <UrgencyBar data-id="element-1" data-mp="86cnpbiddjmt" />
      <HeroSection data-id="element-2" data-mp="83qgjcze5654" />
      <TransformationSection data-id="element-3" data-mp="3gl4sdjnv24l3" />
      <RealResultsSection data-id="element-4" data-mp="3gmfu7dxqx29k" />

      <Suspense fallback={<div className="min-h-[200px]" data-id="element-6" data-mp="3gj1rg4l66r1l" />} data-id="element-5" data-mp="3glny8208l2ir">
        <SolutionSection data-id="element-7" data-mp="3bn30qacdcwy0" />
        <IncludesSection data-id="element-8" data-mp="3bnuvxk220snr" />
        <TestimonialsSection data-id="element-9" data-mp="3bkgse8hnmdeq" />
        <BonusesSection data-id="element-10" data-mp="3qbpq74vpn52y" />
        <UrgencyOfferSection data-id="element-11" data-mp="3qbze8mx73260" />
        <PricingSection data-id="element-12" data-mp="3qdajysa7ajzr" />
        <FAQSection data-id="element-13" data-mp="3lkr6dvbijouy" />
        <FooterSection data-id="element-14" data-mp="3lk7kk3iqsgbn" />
        <SocialProofPopup data-id="element-15" data-mp="3liwkadoi9qpa" />
      </Suspense>
    </div>;
}